import { memo, type ReactNode } from 'react'

import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

import { type MemberRoleBadgeProps, ORGANIZATION_ROLE_LABELS } from './members.interface'

const ROLE_VARIANT_MAP: Record<string, 'default' | 'secondary'> = {
  'org:admin': 'default',
  'org:member': 'secondary',
}

/**
 * Displays organization member role as a styled badge.
 * Admin roles show with primary styling, member roles with secondary styling.
 */
const MemberRoleBadgeBase: React.FC<MemberRoleBadgeProps> = ({
  memberRole,
  className,
}): ReactNode => {
  const label = ORGANIZATION_ROLE_LABELS[memberRole]
  const variant = ROLE_VARIANT_MAP[memberRole] ?? 'secondary'

  return (
    <Badge variant={variant} className={cn('member-role-badge', className)}>
      {label}
    </Badge>
  )
}

export const MemberRoleBadge = memo(MemberRoleBadgeBase)

MemberRoleBadge.displayName = 'MemberRoleBadge'
